import { isEqual, omit }                    from "lodash"
import { CreateSurveyQuestionRequestData }  from "types/apis/surveyInterfaces"
import { APIData }                          from "types/cms/frontendTypes"

export const SurveyQBUtils = {

  getQuestionDiff : (newQuestion : CreateSurveyQuestionRequestData,
                     oldQuestion : Partial<APIData<'api::survey-question.survey-question'>>) => {

    const diff : Partial<APIData<'api::survey-question.survey-question'>> = {}

    if (!isEqual(newQuestion.type, oldQuestion.type)) diff.type = newQuestion.type
    if (!isEqual(newQuestion.group, oldQuestion.group)) diff.group = newQuestion.group
    if (!isEqual(newQuestion.category, oldQuestion.category)) diff.category = newQuestion.category
    if (!isEqual(newQuestion.impactShc, oldQuestion.impactShc)) diff.impactShc = newQuestion.impactShc
    if (!isEqual(newQuestion.impactItemization, oldQuestion.impactItemization)) diff.impactItemization = newQuestion.impactItemization
    if (!isEqual(newQuestion.impactReco, oldQuestion.impactReco)) diff.impactReco = newQuestion.impactReco                
    if (!isEqual(newQuestion.fuelTypes, oldQuestion.fuelTypes)) diff.fuelTypes = newQuestion.fuelTypes
    if (!isEqual(newQuestion.maxLevel, oldQuestion.maxLevel)) diff.maxLevel = newQuestion.maxLevel
    if (!isEqual(newQuestion.title, oldQuestion.title)) diff.title = newQuestion.title
    if (!isEqual(newQuestion.info, oldQuestion.info)) diff.info = newQuestion.info
    if (!isEqual(newQuestion.profileCode, oldQuestion.profileCode)) diff.profileCode = newQuestion.profileCode
    if (!isEqual(newQuestion.stateMapper, oldQuestion.stateMapper)) diff.stateMapper = newQuestion.stateMapper
    if (!isEqual(newQuestion.verificationStatus, oldQuestion.verificationStatus)) diff.verificationStatus = newQuestion.verificationStatus
    
    // Normalize localizations for comparison (empty array vs undefined)
    const oldLocalizations = oldQuestion.localizations || []
    const newLocalizations = newQuestion.localizations || []
    if (!isEqual(oldLocalizations, newLocalizations)) {
      // Only include if new localizations has content, otherwise omit from diff
      if (newLocalizations.length > 0) {
        diff.localizations = newLocalizations
      }
    }

    // Normalize choices for comparison - remove IDs and ensure consistent structure
    const normalizeChoices = (choices: any[] | undefined) => {
      const choicesArray = choices || [];
      return choicesArray.map((choice, index) => {
        const normalized = omit(choice, 'id');
        // Ensure order is set (use index + 1 if missing, but preserve existing order)
        if (normalized.order === undefined || normalized.order === null) {
          normalized.order = index + 1;
        }
        // Normalize subChoices
        if (normalized.subChoices && Array.isArray(normalized.subChoices)) {
          normalized.subChoices = normalized.subChoices.map((sc: any, scIndex: number) => {
            const normalizedSub = omit(sc, 'id');
            // Ensure order is set for subChoices too
            if (normalizedSub.order === undefined || normalizedSub.order === null) {
              normalizedSub.order = scIndex + 1;
            }
            return normalizedSub;
          });
        }
        return normalized;
      });
    };

    const oldChoicesWithoutID = normalizeChoices(oldQuestion.choices);
    const newChoicesWithoutID = normalizeChoices(newQuestion.choices);
    
    if (!isEqual(oldChoicesWithoutID, newChoicesWithoutID)) {
      diff.choices = newChoicesWithoutID as any;
    }
    return diff
  },
}